module.exports = __webpack_public_path__ + "img/3CH_CT.89b33621.png";